import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Users, Building, MessageSquare, ChevronRight } from "lucide-react";
export const PartnershipsPage = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white" data-id="element-1330">
      <button onClick={() => navigate("/")} className="fixed top-4 left-4 flex items-center gap-2 text-gray-600 hover:text-[#6366f1] transition-colors" data-id="element-1331">
        <ArrowLeft size={20} data-id="element-1332" />
        Back to Home
      </button>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-1333">
        <div className="text-center mb-16" data-id="element-1334">
          <div className="flex justify-center mb-6" data-id="element-1335">
            <div className="w-16 h-16 bg-[#d5ff00]/20 rounded-2xl flex items-center justify-center" data-id="element-1336">
              <div className="w-8 h-8 text-[#6366f1]" data-id="element-1337" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-1338">
            Partner with Gigi.ai
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1339">
            Join forces with us to revolutionize B2B outreach and create
            meaningful connections at scale
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-1340">
          <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100" data-id="element-1341">
            <Users className="w-8 h-8 text-[#6366f1] mb-4" data-id="element-1342" />
            <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-1343">
              Sales Partners
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-1344">
              Help your clients automate their outreach while earning
              competitive commissions
            </p>
            <button className="flex items-center text-[#6366f1] hover:text-[#5457e5] font-medium" data-id="element-1345">
              Learn more <ChevronRight className="w-4 h-4 ml-1" data-id="element-1346" />
            </button>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100" data-id="element-1347">
            <Building className="w-8 h-8 text-[#6366f1] mb-4" data-id="element-1348" />
            <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-1349">
              Technology Partners
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-1350">
              Integrate with our API to add AI-powered outreach to your platform
            </p>
            <button className="flex items-center text-[#6366f1] hover:text-[#5457e5] font-medium" data-id="element-1351">
              Learn more <ChevronRight className="w-4 h-4 ml-1" data-id="element-1352" />
            </button>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100" data-id="element-1353">
            <MessageSquare className="w-8 h-8 text-[#6366f1] mb-4" data-id="element-1354" />
            <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-1355">
              Agency Partners
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-1356">
              Enhance your service offerings with our AI-powered outreach
              solutions
            </p>
            <button className="flex items-center text-[#6366f1] hover:text-[#5457e5] font-medium" data-id="element-1357">
              Learn more <ChevronRight className="w-4 h-4 ml-1" data-id="element-1358" />
            </button>
          </div>
        </div>
        <div className="bg-gray-50 rounded-xl p-8 border border-gray-200" data-id="element-1359">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1360">
            Why Partner With Us?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1361">
            <div className="flex gap-4" data-id="element-1362">
              <div className="w-12 h-12 bg-[#d5ff00]/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-1363">
                <div className="text-2xl font-bold text-[#6366f1]" data-id="element-1364">1</div>
              </div>
              <div data-id="element-1365">
                <h3 className="font-semibold text-gray-900 mb-1" data-id="element-1366">
                  Competitive Compensation
                </h3>
                <p className="text-gray-600" data-id="element-1367">
                  Earn up to 30% recurring commission on referred customers
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-1368">
              <div className="w-12 h-12 bg-[#d5ff00]/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-1369">
                <div className="text-2xl font-bold text-[#6366f1]" data-id="element-1370">2</div>
              </div>
              <div data-id="element-1371">
                <h3 className="font-semibold text-gray-900 mb-1" data-id="element-1372">
                  Dedicated Support
                </h3>
                <p className="text-gray-600" data-id="element-1373">
                  Get priority access to our team and resources
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-1374">
              <div className="w-12 h-12 bg-[#d5ff00]/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-1375">
                <div className="text-2xl font-bold text-[#6366f1]" data-id="element-1376">3</div>
              </div>
              <div data-id="element-1377">
                <h3 className="font-semibold text-gray-900 mb-1" data-id="element-1378">
                  Co-Marketing Opportunities
                </h3>
                <p className="text-gray-600" data-id="element-1379">
                  Joint campaigns and content creation
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-1380">
              <div className="w-12 h-12 bg-[#d5ff00]/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-1381">
                <div className="text-2xl font-bold text-[#6366f1]" data-id="element-1382">4</div>
              </div>
              <div data-id="element-1383">
                <h3 className="font-semibold text-gray-900 mb-1" data-id="element-1384">
                  Early Access
                </h3>
                <p className="text-gray-600" data-id="element-1385">
                  Be the first to try new features and integrations
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-1386">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1387">
            Ready to Partner?
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-1388">
            Let's discuss how we can grow together
          </p>
          <button onClick={() => navigate("/auth")} className="px-8 py-4 bg-[#d5ff00] text-gray-900 rounded-lg text-lg font-semibold hover:bg-[#c0e600] shadow-lg" data-id="element-1389">
            Apply Now
          </button>
        </div>
      </div>
    </div>;
};